import { useMemo } from 'react'
import { TraitId } from '@cibo/core'
import { Autocomplete } from '@mui/material'
import { propEq } from 'ramda'
import { useAllRequirements } from '../../hooks'
import { useFormikContext } from 'formik'

import TextField from '@mui/material/TextField'

import DETAIL_TEMPLATES from './details/detail_templates.json'

type BulkTraitSetterProps = {
  traitId: TraitId
}

const optionTest = (option: { label: string }, value: { label: string }) => {
  return value.label === option.label
}

export const BulkTraitSetter = ({ traitId, ...autocompleteProps }: BulkTraitSetterProps) => {
  const TRAIT_TEMPLATES = DETAIL_TEMPLATES.filter(propEq('traitId', traitId as string))
  const allRequirements = useAllRequirements()
  const { setFieldValue } = useFormikContext()

  const traitRequirements = useMemo(
    () => allRequirements.data?.filter(propEq('traitId', traitId)),
    [allRequirements.data]
  )

  const onSetAll = (template: any) => {
    traitRequirements.forEach(req => {
      setFieldValue(
        `${traitId}-${req.year}`,
        {
          ...template,
          detail: {
            ...template.detail,
            year: req.year,
          },
        },
        false
      )
    })
  }

  return (
    <Autocomplete
      options={TRAIT_TEMPLATES}
      getOptionLabel={option => option.label}
      selectOnFocus
      isOptionEqualToValue={optionTest}
      onChange={(event: any, template: any) => onSetAll(template)}
      {...autocompleteProps}
      renderInput={params => (
        <TextField {...params} label={`set all ${traitId}...`} variant="outlined" />
      )}
    />
  )
}
